import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { Bathroom } from 'landings/bathroom';
import { RemoteProps } from './widgets-types';

export const BathroomRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <Bathroom />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
